export default __webpack_public_path__ + "static/media/diplo.03ad151b.zip";